import { inheritsLoose as _inheritsLoose, objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends, createClass as _createClass, objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import { mergeCssModules, getWrapperClassName, getWrapperId } from '@emoney/kyber-helpers';
import classNames$1 from 'classnames';
import React__default, { cloneElement, Component } from 'react';
import { Transition } from 'react-transition-group';
import defaultCssModule from './collapse.module.less.js';

/**
 *Component providing a stateful wrapper to show/hide children.
 */

var Collapse = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Collapse, _Component);

  function Collapse(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      isShown: props.isShown || false
    };
    _this.animationTimeout = 150;
    return _this;
  }

  var _proto = Collapse.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.isShown !== undefined && prevProps.isShown !== this.props.isShown && this.props.isShown !== this.state.isShown) {
      this.setState({
        isShown: this.props.isShown
      });
    }
  };

  _proto.collapse = function collapse() {
    var isShown = !this.state.isShown;
    this.setState({
      isShown: isShown
    });
    this.props.onCollapse(isShown);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        trigger = _this$props.trigger,
        openedStateTrigger = _this$props.openedStateTrigger,
        onCollapse = _this$props.onCollapse,
        isShown = _this$props.isShown,
        cssModuleProp = _this$props.cssModule,
        restProps = _objectWithoutPropertiesLoose(_this$props, ["children", "className", "trigger", "openedStateTrigger", "onCollapse", "isShown", "cssModule"]);

    var cssModule = mergeCssModules(cssModuleProp, defaultCssModule);
    var classes = classNames$1(className, cssModule.collapse);
    return /*#__PURE__*/React__default.createElement("div", {
      className: getWrapperClassName({
        className: className
      }),
      id: getWrapperId({
        id: restProps.id
      })
    }, this.trigger, /*#__PURE__*/React__default.createElement(Transition, {
      in: this.state.isShown,
      timeout: this.animationTimeout
    }, function (status) {
      return /*#__PURE__*/React__default.createElement("div", _extends({
        className: classNames$1(classes, cssModule[status])
      }, restProps), children);
    }));
  };

  _createClass(Collapse, [{
    key: "trigger",
    get: function get() {
      var _this2 = this;

      var isShown = this.state.isShown;
      var openedStateTrigger = this.props.openedStateTrigger || this.props.trigger;
      var trigger = isShown ? openedStateTrigger : this.props.trigger;

      if (!trigger) {
        return null;
      }

      var originalClick = trigger.props.onClick || function () {};

      var onClick = function onClick() {
        _this2.collapse();

        originalClick();
      };

      var triggerId = {
        id: trigger.props.id || this.props.id + "-trigger"
      };
      return /*#__PURE__*/cloneElement(trigger, _objectSpread2({
        role: 'button',
        'aria-expanded': isShown,
        onClick: onClick
      }, triggerId));
    }
  }]);

  return Collapse;
}(Component);

Collapse.defaultProps = {
  openedStateTrigger: null,
  trigger: null,
  onCollapse: function onCollapse() {}
};
Collapse.displayName = 'Collapse';

export default Collapse;
